import { render } from "./OrthopedicsView.vue?vue&type=template&id=67d7a7fe&scoped=true"
import script from "./OrthopedicsView.vue?vue&type=script&lang=js"
export * from "./OrthopedicsView.vue?vue&type=script&lang=js"

import "./OrthopedicsView.vue?vue&type=style&index=0&id=67d7a7fe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d7a7fe"]])

export default __exports__